import { render, staticRenderFns } from "./PremiumTextRightModal.vue?vue&type=template&id=37b511c9&"
import script from "./PremiumTextRightModal.vue?vue&type=script&lang=js&"
export * from "./PremiumTextRightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports